module.exports = __webpack_public_path__ + "img/peac.687331f8.jpg";